/**
 * Ai được mở trang TRA CỨU HỌC VIÊN DAT (`/admin/session/student`).
 *
 * Vì sao tách riêng: màn cảnh báo lịch cabin trùng (`AdminDrivingGuard`) cho cả
 * **giáo viên** và **reporter** vào, nhưng trang tra cứu (`AdminGuard`) thì
 * không. Nếu cứ hiện nút tra cứu cho mọi người thì hai vai đó bấm vào sẽ bị đá
 * về trang đăng nhập admin — một ngõ cụt, và người dùng tưởng mình hết phiên.
 *
 * Nên tập vai phải nằm ở **một chỗ duy nhất** mà cả `AdminGuard` lẫn nút bấm
 * cùng đọc. Chép tay tập vai sang chỗ thứ hai thì lần sau ai sửa guard sẽ không
 * sửa nút, và cái ngõ cụt quay lại lặng lẽ.
 *
 * Hàm thuần, không đọc localStorage: gọi là truyền `user` vào, để test được.
 */
import { ROLE } from '../constants/roles.constant';

/** Đúng tập vai mà `AdminGuard` đang cho qua. */
export const VAI_TRA_CUU_HOC_VIEN = [
  ROLE.ADMIN,
  ROLE.DRIVING.ADMIN,
  ROLE.DRIVING.DAT_ADMIN,
];

/**
 * @param {{ role?: Array<number> }|null|undefined} user thường là `user-info` trong localStorage
 * @returns {boolean}
 */
export function coQuyenTraCuuHocVien(user) {
  // `user?.role.includes(...)` ném TypeError khi tài khoản không có `role` —
  // đủ để trắng màn hình. Kiểm mảng trước rồi mới hỏi.
  const vai = user && Array.isArray(user.role) ? user.role : [];
  return VAI_TRA_CUU_HOC_VIEN.some((v) => vai.includes(v));
}

/** Đọc `user-info` trong localStorage rồi trả lời — dùng trực tiếp ở trang. */
export function coQuyenTraCuuHocVienHienTai() {
  try {
    return coQuyenTraCuuHocVien(JSON.parse(localStorage.getItem('user-info')));
  } catch (e) {
    // `user-info` hỏng thì coi như không có quyền: thà ẩn nút còn hơn dẫn
    // người dùng tới trang đăng nhập.
    return false;
  }
}
